// The "Search by image" section at the top of the Browse filter sidebar.
//
// Renders nothing until an image is attached, which is what makes it read as part of the
// filter stack rather than an empty heading: the sidebar's other groups are all SSR and
// always present, so this one has to earn its space.
//
// It is a second Preact root over the same store as the button. The sidebar is server
// rendered from `ctx.filters`, so there is no component tree to hang this off — see
// features/searchImage/init.ts.
import { useEffect, useState } from "preact/hooks";
import { getAction } from "../../actionRegistry";
import { onSearchImageChange, setSearchImage, type SearchImage } from "./store";

export function SearchImageChip() {
  const [image, setImage] = useState<SearchImage | null>(null);

  useEffect(() => onSearchImageChange(setImage), []);

  if (!image) return null;

  return (
    <div class="window-sidebar-filter search-image-chip">
      <div class="window-sidebar-header">Search by image</div>
      <div class="search-image-chip-row">
        <img class="search-image-chip-thumb" src={image.preview} alt="" />
        <span class="search-image-chip-name" title={image.name}>
          {image.name}
        </span>
        <span
          class="search-image-chip-remove"
          title="Remove this image from the search"
          onClick={() => {
            setSearchImage(null);
            // Re-run so the results stop being ranked by an image that is no longer shown.
            getAction("searchtimed")?.();
          }}
        >
          <i class="fas fa-trash" />
        </span>
      </div>
    </div>
  );
}
